module.exports = __webpack_public_path__ + "img/bn15.10d07e88.png";